import type { StaticRouteKey } from "../static-route.type";
import type { StaticRouteLinkOptions } from "./static-route-link.type";

import { generatePath } from "react-router";

import { useOrganizationContext } from "@/modules/organization/organization-context";

import { STATIC_ROUTES_CONFIGS } from "../static-route.constant";

export const useStaticRouteLinkUtils = () => {
  const { contextSlug } = useOrganizationContext();

  const getRouteLink = (
    routeKey: StaticRouteKey,
    { customContext, search }: StaticRouteLinkOptions = {}
  ) => {
    const route = STATIC_ROUTES_CONFIGS[routeKey].route;
    const params = { context: customContext ?? `${contextSlug}` };
    const link = generatePath(route, params);
    return search ? `${link}${search}` : link;
  };

  return {
    getRouteLink,
  };
};

export const useStaticRouteLink = (
  routeKey: StaticRouteKey,
  options?: StaticRouteLinkOptions
) => {
  const { getRouteLink } = useStaticRouteLinkUtils();
  return getRouteLink(routeKey, options);
};
